import React from "react";
import "./App.css";
import { Header } from "./header/Header";
import { HKCalendar } from "./calendar/Calendar";
import { Infobox } from "./infobox/Infobox";
import {Footer} from "./footer/Footer";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import {Astrid} from "./homepage/Astrid";

export const HOMES = [
  "Home Astrid",
  "Home Bertha",
  "Home Boudewijn",
  "Home Confabula",
  "Home Fabiola",
  "Home Mercator",
  "Home Savania",
  "Home Vermeylen",
];

const componentMap = new Map([
    ['Home Astrid', <Astrid/>]
])

const homeRoutes: JSX.Element[] = [];
HOMES.forEach((h) => {
    homeRoutes.push(<Route path={`/${h}`}>
        {componentMap.get(h)}
    </Route>)
})



function App() {
  return (
    <Router>
      <Header />
        <Switch>
            <Route exact path="/">
                <HKCalendar />
                <Infobox />
            </Route>
            {homeRoutes}
        </Switch>
      <Footer/>
    </Router>
  );
}

export default App;
